import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import http from "../../Services/httpService";
import config from "../../config.json";
import { getConfirmAlert, showToast } from "../../Services/appAlerts";
import { menuConfig } from "../../app/menuConfig";

const PERM_STYLES = {
    modalContent: {
        borderRadius: "24px",
        overflow: "hidden",
        border: "1px solid rgba(226, 232, 240, 1)",
        boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
    },
    modalDialog: {
        maxWidth: "980px"
    },
    modalHeader: {
        padding: "20px 24px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.8)",
        background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 56%, #f8fafc 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "16px"
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        minWidth: 0
    },
    titleIcon: {
        width: "42px",
        height: "42px",
        borderRadius: "14px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eef2ff",
        color: "#4f46e5",
        border: "1px solid rgba(224, 231, 255, 1)",
        fontSize: "18px",
        flexShrink: 0
    },
    modalTitle: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        margin: 0
    },
    modalSubtitle: {
        margin: "4px 0 0 0",
        color: "#64748b",
        fontSize: "13px",
        lineHeight: 1.5
    },
    modalBody: {
        padding: "24px",
        background: "#f8fafc",
        maxHeight: "calc(100vh - 200px)",
        overflowY: "auto"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "18px",
        alignItems: "stretch",
        padding: "4px"
    },
    summaryGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
        gap: "12px",
        marginBottom: "18px"
    },
    summaryCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        borderRadius: "18px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        padding: "14px 16px",
        boxShadow: "0 10px 22px rgba(15, 23, 42, 0.04)"
    },
    summaryIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "12px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#2563eb",
        flexShrink: 0
    },
    summaryLabel: {
        fontSize: "11px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "7px"
    },
    summaryValue: {
        fontSize: "24px",
        fontWeight: 800,
        lineHeight: 1,
        color: "#0f172a"
    },
    quickActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "18px",
        padding: "14px 16px",
        borderRadius: "18px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)"
    },
    quickText: {
        margin: 0,
        color: "#475569",
        fontSize: "13px",
        lineHeight: 1.5
    },
    actionRow: {
        display: "flex",
        gap: "8px",
        flexWrap: "wrap"
    },
    lightButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "8px 13px",
        fontSize: "12px",
        fontWeight: 800,
        outline: "none",
        boxShadow: "none"
    },
    card: {
        borderRadius: "20px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fcfdff 100%)",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%"
    },
    cardHeader: {
        padding: "14px 18px",
        background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.9) 100%)",
        borderBottom: "1px solid rgba(226, 232, 240, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px"
    },
    cardBody: {
        padding: "18px"
    },
    sectionTitle: {
        fontSize: "14px",
        fontWeight: 800,
        color: "#0f172a",
        marginBottom: "12px",
        display: "flex",
        alignItems: "center"
    },
    subSection: {
        marginLeft: "18px",
        marginTop: "8px",
        paddingLeft: "14px",
        borderLeft: "2px solid rgba(226, 232, 240, 0.6)"
    },
    menuLabel: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#334155"
    },
    subMenuLabel: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#475569"
    },
    leafLabel: {
        fontSize: "12px",
        fontWeight: 500,
        color: "#64748b"
    },
    modalFooter: {
        padding: "16px 24px",
        borderTop: "1px solid rgba(226, 232, 240, 0.8)",
        background: "#ffffff"
    },
    cancelButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#475569",
        padding: "10px 24px",
        fontSize: "12px",
        fontWeight: 800
    },
    saveButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        padding: "10px 28px",
        fontSize: "13px",
        fontWeight: 700,
        background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
        color: "#ffffff",
        border: "none",
        boxShadow: "0 10px 15px -3px rgba(37, 99, 235, 0.3)",
        transition: "all 0.2s ease"
    },
    innerGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: "16px"
    },
    closeButton: {
        width: "38px",
        height: "38px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#64748b",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: 800,
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
        flexShrink: 0
    },
    checkboxWrapper: {
        marginBottom: "8px"
    },
    permissionRow: {
        minHeight: "36px",
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
        padding: "7px 10px",
        background: "#ffffff",
        border: "1px solid transparent"
    },
    permissionRowChecked: {
        background: "#eff6ff",
        borderColor: "rgba(191, 219, 254, 1)"
    },
    sectionCard: {
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        padding: "12px"
    },
    countBadge: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "999px",
        padding: "5px 9px",
        background: "#ffffff",
        border: "1px solid rgba(191, 219, 254, 1)",
        color: "#1d4ed8",
        fontSize: "11px",
        fontWeight: 800,
        whiteSpace: "nowrap"
    }
};

const AddEditPermission = ({ showHide, handleModalShowHide, handlePermissionShowHide, roleid, roleSource }) => {
    const [menuObjects, setMenuObjects] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const refMenuObjects = menuConfig;

    const getPermissionCounts = (items = []) => {
        return items.reduce(
            (totals, item) => {
                totals.total += 1;
                if (item.isChecked) totals.selected += 1;
                if (item.menus) {
                    const childTotals = getPermissionCounts(item.menus);
                    totals.total += childTotals.total;
                    totals.selected += childTotals.selected;
                }
                return totals;
            },
            { total: 0, selected: 0 }
        );
    };

    const setCheckedDeep = (items, checked) =>
        items.map((item) => ({
            ...item,
            isChecked: checked,
            menus: item.menus ? setCheckedDeep(item.menus, checked) : item.menus,
        }));

    const permissionCounts = getPermissionCounts(menuObjects);
    const permissionPercent = permissionCounts.total > 0
        ? Math.round((permissionCounts.selected / permissionCounts.total) * 100)
        : 0;

    const handleSetAllPermissions = (checked) => {
        setMenuObjects(setCheckedDeep(menuObjects, checked));
    };

    useEffect(() => {
        const fetchPermissions = async () => {
            if (roleid > 0) {
                try {
                    const { data } = await http.get(config.GetRolePermission + roleid);
                    if (data && data !== "") {
                        setMenuObjects(data);
                    } else {
                        setMenuObjects(JSON.parse(JSON.stringify(refMenuObjects)));
                    }
                } catch (error) {
                    setMenuObjects(JSON.parse(JSON.stringify(refMenuObjects)));
                }
            } else {
                setMenuObjects(JSON.parse(JSON.stringify(refMenuObjects)));
            }
        };

        if (showHide) {
            setIsSaving(false);
            fetchPermissions();
        }
    }, [roleid, showHide, refMenuObjects]);

    const renderCheckBox = (label, name, handleOnChange, isChecked, labelStyle = {}) => {
        return (
            <div
                style={{
                    ...PERM_STYLES.checkboxWrapper,
                    ...PERM_STYLES.permissionRow,
                    ...(isChecked ? PERM_STYLES.permissionRowChecked : {}),
                }}
            >
                <div className="custom-control custom-checkbox premium-checkbox">
                    <input
                        className="custom-control-input"
                        id={name}
                        type="checkbox"
                        name={name}
                        onChange={handleOnChange}
                        checked={Boolean(isChecked)}
                        disabled={isSaving}
                    />
                    <label
                        className="custom-control-label form-control-label"
                        htmlFor={name}
                        style={{ cursor: "pointer", ...labelStyle }}
                    >
                        {label}
                    </label>
                </div>
            </div>
        );
    };

    const handleSystemAdminChange = ({ currentTarget }) => {
        const mid = currentTarget.id.split("_");
        const updatedMenuObjects = [...menuObjects];

        if (mid[0] === "m") {
            const menuId = parseInt(mid[1]);
            const menu = updatedMenuObjects.find(m => m.id === menuId);
            if (menu) {
                menu.isChecked = currentTarget.checked;
                if (menu.menus) {
                    for (const smenu of menu.menus) {
                        smenu.isChecked = currentTarget.checked;
                        if (smenu.menus) {
                            for (const ssmenu of smenu.menus) {
                                ssmenu.isChecked = currentTarget.checked;
                                if (ssmenu.menus) {
                                    for (const sssmenu of ssmenu.menus) {
                                        sssmenu.isChecked = currentTarget.checked;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else if (mid[0] === "sm") {
            const smenuId = parseInt(mid[1]);
            const menuId = parseInt(mid[2]);
            const menu = updatedMenuObjects.find(m => m.id === menuId);
            if (menu && menu.menus) {
                const smenu = menu.menus.find(sm => sm.id === smenuId);
                if (smenu) {
                    smenu.isChecked = currentTarget.checked;
                    if (smenu.menus) {
                        for (const ssmenu of smenu.menus) {
                            ssmenu.isChecked = currentTarget.checked;
                            if (ssmenu.menus) {
                                for (const sssmenu of ssmenu.menus) {
                                    sssmenu.isChecked = currentTarget.checked;
                                }
                            }
                        }
                    }
                }
            }
        } else if (mid[0] === "ssm") {
            const ssmenuId = parseInt(mid[1]);
            const smenuId = parseInt(mid[2]);
            const menuId = parseInt(mid[3]);
            const menu = updatedMenuObjects.find(m => m.id === menuId);
            if (menu && menu.menus) {
                const smenu = menu.menus.find(sm => sm.id === smenuId);
                if (smenu && smenu.menus) {
                    const ssmenu = smenu.menus.find(ssm => ssm.id === ssmenuId);
                    if (ssmenu) {
                        ssmenu.isChecked = currentTarget.checked;
                        if (ssmenu.menus) {
                            for (const sssmenu of ssmenu.menus) {
                                sssmenu.isChecked = currentTarget.checked;
                            }
                        }
                    }
                }
            }
        } else if (mid[0] === "sssm") {
            const sssmenuId = parseInt(mid[1]);
            const ssmenuId = parseInt(mid[2]);
            const smenuId = parseInt(mid[3]);
            const menuId = parseInt(mid[4]);
            const menu = updatedMenuObjects.find(m => m.id === menuId);
            if (menu && menu.menus) {
                const smenu = menu.menus.find(sm => sm.id === smenuId);
                if (smenu && smenu.menus) {
                    const ssmenu = smenu.menus.find(ssm => ssm.id === ssmenuId);
                    if (ssmenu && ssmenu.menus) {
                        const sssmenu = ssmenu.menus.find(sssm => sssm.id === sssmenuId);
                        if (sssmenu) {
                            sssmenu.isChecked = currentTarget.checked;
                        }
                    }
                }
            }
        }

        setMenuObjects(updatedMenuObjects);
    };

    const handleSubmit = async () => {
        const permissionObj = {
            roleId: roleid,
            roleSource: roleSource,
            permissionRights: JSON.stringify(menuObjects),
        };
        const result = await getConfirmAlert("Update Permissions?", "Are you sure you want to change permissions for this user?", "warning");
        if (result.isConfirmed) {
            setIsSaving(true);
            try {
                await http.post(config.AddEditRolePermission, permissionObj);
                showToast("Permissions updated successfully", "success");
                handlePermissionShowHide();
            } catch (error) {
                showToast("Failed to update permissions", "error");
            } finally {
                setIsSaving(false);
            }
        }
    };

    return (
        <Modal
            show={showHide}
            size="lg"
            centered
            dialogClassName="permission-modal-dialog"
            contentClassName="permission-modal-content"
        >
            <Modal.Header style={PERM_STYLES.modalHeader}>
                <div style={PERM_STYLES.headerRow}>
                    <div style={PERM_STYLES.titleRow}>
                        <span style={PERM_STYLES.titleIcon}>
                            <i className="fa fa-shield" aria-hidden="true"></i>
                        </span>
                        <div>
                            <Modal.Title style={PERM_STYLES.modalTitle}>
                                User Access Permissions
                            </Modal.Title>
                            <p style={PERM_STYLES.modalSubtitle}>
                                Configure menu visibility and access rights for this partner user.
                            </p>
                        </div>
                    </div>
                    <button
                        type="button"
                        style={PERM_STYLES.closeButton}
                        onClick={handleModalShowHide}
                        aria-label="Close"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body style={PERM_STYLES.modalBody}>
                <style>{`
                    .permission-modal-dialog {
                        max-width: ${PERM_STYLES.modalDialog.maxWidth};
                    }
                    .permission-modal-content {
                        border-radius: ${PERM_STYLES.modalContent.borderRadius};
                        overflow: ${PERM_STYLES.modalContent.overflow};
                        border: ${PERM_STYLES.modalContent.border};
                        box-shadow: ${PERM_STYLES.modalContent.boxShadow};
                    }
                    .permission-modal-content .btn,
                    .permission-modal-content .btn:focus,
                    .permission-modal-content .btn:active {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                    .premium-checkbox,
                    .premium-checkbox .custom-control-label {
                        width: 100%;
                    }
                    .premium-checkbox .custom-control-label {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        background: transparent !important;
                    }
                    .premium-checkbox .custom-control-label::before {
                        border-radius: 6px;
                        border: 2px solid #cbd5e1;
                        width: 20px;
                        height: 20px;
                        top: 2px;
                    }
                    .premium-checkbox .custom-control-label::after {
                        width: 20px;
                        height: 20px;
                        top: 2px;
                    }
                    .premium-checkbox .custom-control-input:checked ~ .custom-control-label::before {
                        background-color: #2563eb;
                        border-color: #2563eb;
                    }
                    .permission-action:hover {
                        text-decoration: none;
                        transform: translateY(-1px);
                        box-shadow: 0 8px 18px rgba(37, 99, 235, 0.08);
                    }
                    @media (max-width: 767.98px) {
                        .permission-modal-dialog {
                            max-width: calc(100% - 18px);
                        }
                    }
                `}</style>
                <div style={PERM_STYLES.summaryGrid}>
                    <div style={PERM_STYLES.summaryCard}>
                        <span style={PERM_STYLES.summaryIcon}>
                            <i className="fa fa-list-ul" aria-hidden="true"></i>
                        </span>
                        <div>
                            <div style={PERM_STYLES.summaryLabel}>Permission Items</div>
                            <div style={PERM_STYLES.summaryValue}>{permissionCounts.total}</div>
                        </div>
                    </div>
                    <div style={PERM_STYLES.summaryCard}>
                        <span style={{ ...PERM_STYLES.summaryIcon, background: "#f0fdf4", color: "#166534" }}>
                            <i className="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
                        <div>
                            <div style={PERM_STYLES.summaryLabel}>Granted</div>
                            <div style={PERM_STYLES.summaryValue}>{permissionCounts.selected}</div>
                        </div>
                    </div>
                    <div style={PERM_STYLES.summaryCard}>
                        <span style={{ ...PERM_STYLES.summaryIcon, background: "#fffbeb", color: "#92400e" }}>
                            <i className="fa fa-percent" aria-hidden="true"></i>
                        </span>
                        <div>
                            <div style={PERM_STYLES.summaryLabel}>Coverage</div>
                            <div style={PERM_STYLES.summaryValue}>{permissionPercent}%</div>
                        </div>
                    </div>
                </div>

                <div style={PERM_STYLES.quickActions}>
                    <p style={PERM_STYLES.quickText}>
                        Use quick actions for broad access changes, then fine tune individual menu permissions below.
                    </p>
                    <div style={PERM_STYLES.actionRow}>
                        <button
                            type="button"
                            className="permission-action"
                            style={PERM_STYLES.lightButton}
                            onClick={() => handleSetAllPermissions(true)}
                            disabled={isSaving}
                        >
                            <i className="fa fa-check" aria-hidden="true"></i>
                            Grant All
                        </button>
                        <button
                            type="button"
                            className="permission-action"
                            style={{ ...PERM_STYLES.lightButton, background: "#ffffff", color: "#475569", borderColor: "rgba(226, 232, 240, 1)" }}
                            onClick={() => handleSetAllPermissions(false)}
                            disabled={isSaving}
                        >
                            <i className="fa fa-ban" aria-hidden="true"></i>
                            Revoke All
                        </button>
                    </div>
                </div>

                <div style={PERM_STYLES.grid}>
                    {menuObjects.map((menu) => {
                        const sectionCounts = getPermissionCounts([menu]);
                        return (
                        <div key={`card_${menu.id}_${menu.name}`} style={PERM_STYLES.card}>
                            <div style={PERM_STYLES.cardHeader}>
                                {renderCheckBox(
                                    menu.name,
                                    `m_${menu.id}`,
                                    handleSystemAdminChange,
                                    menu.isChecked,
                                    PERM_STYLES.menuLabel
                                )}
                                <span style={PERM_STYLES.countBadge}>
                                    {sectionCounts.selected}/{sectionCounts.total}
                                </span>
                            </div>
                            <div style={menu.id === 2 ? { ...PERM_STYLES.cardBody, ...PERM_STYLES.innerGrid } : PERM_STYLES.cardBody}>
                                {menu.menus?.map((smenu) => (
                                    <div key={`smenu_${smenu.id}`} style={menu.id === 2 ? PERM_STYLES.sectionCard : { marginBottom: "16px" }}>
                                        {renderCheckBox(
                                            smenu.name,
                                            `sm_${smenu.id}_${menu.id}`,
                                            handleSystemAdminChange,
                                            smenu.isChecked,
                                            PERM_STYLES.subMenuLabel
                                        )}
                                        {smenu.menus && (
                                            <div style={PERM_STYLES.subSection}>
                                                {smenu.menus.map((ssmenu) => (
                                                    <div key={`ssmenu_${ssmenu.id}`} style={{ marginBottom: "10px" }}>
                                                        {renderCheckBox(
                                                            ssmenu.name,
                                                            `ssm_${ssmenu.id}_${smenu.id}_${menu.id}`,
                                                            handleSystemAdminChange,
                                                            ssmenu.isChecked,
                                                            PERM_STYLES.leafLabel
                                                        )}
                                                        {ssmenu.menus && (
                                                            <div style={{ marginLeft: "24px", marginTop: "4px" }}>
                                                                {ssmenu.menus.map((sssmenu) => (
                                                                    <div key={`sssmenu_${sssmenu.id}`}>
                                                                        {renderCheckBox(
                                                                            sssmenu.name,
                                                                            `sssm_${sssmenu.id}_${ssmenu.id}_${smenu.id}_${menu.id}`,
                                                                            handleSystemAdminChange,
                                                                            sssmenu.isChecked,
                                                                            { ...PERM_STYLES.leafLabel, fontSize: "11px", color: "#94a3b8" }
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        );
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer style={PERM_STYLES.modalFooter}>
                <button
                    className="btn"
                    style={PERM_STYLES.cancelButton}
                    onClick={handleModalShowHide}
                    disabled={isSaving}
                >
                    <i className="fa fa-times mr-1" aria-hidden="true"></i>
                    Close
                </button>
                <button
                    className="btn"
                    style={PERM_STYLES.saveButton}
                    onClick={handleSubmit}
                    disabled={isSaving}
                >
                    {isSaving ? (
                        <><i className="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i> Saving...</>
                    ) : (
                        <><i className="fa fa-check-circle mr-1"></i> Save Permissions</>
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditPermission;

